if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();

      this.product = this.closest('[data-product]');
      this.productMedia = this.product.querySelector('product-media');

      this.addEventListener('change', this.onVariantChange);

      // Update product images to match variant on load
      if (this.productMedia) {
        document.addEventListener('DOMContentLoaded', () => {
          this.updateOptions();
          this.updateMasterId();
          this.productMedia.dispatchEvent(new CustomEvent('updateVariant', { detail: this.currentVariant }));
        });
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.updatePrice();
        this.updateShareUrl();

        if (this.productMedia) {
          this.productMedia.dispatchEvent(new CustomEvent('updateVariant', { detail: this.currentVariant }));
        }
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateURL() {
      if (window.location.href.indexOf('/products/') === -1) {
        return;
      }

      if (!this.currentVariant || this.dataset.updateUrl === 'false') {
        return;
      }

      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButtonInput = document.querySelector('share-button [data-share-button-url-input]');

      if (!shareButtonInput) {
        return;
      }

      shareButtonInput.value = window.location.href;
    }

    updateVariantInput() {
      const productForm = this.product.querySelector('product-form');

      if (!productForm) {
        return;
      }

      const input = productForm.querySelector('input[name="id"]');
      const shopPayInput = document.querySelector('[data-shop-pay-input]');

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (shopPayInput) {
        shopPayInput.value = this.currentVariant.id;
        shopPayInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.closest('[data-product]').querySelector('pickup-availability');

      if (!pickUpAvailability) {
        return;
      }

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const productForm = this.product.querySelector('product-form');

      if (!productForm) {
        return;
      }

      productForm.handleErrorMessage();
    }

    updatePrice() {
      const price = this.product.querySelector('[data-product-price]');
      const unitPriceWrapper = this.product.querySelector('[data-product-unit-price-wrapper]');

      if (price) {
        const regularPrices = price.querySelectorAll('[data-product-regular-price]');
        const comparePrices = price.querySelectorAll('[data-product-compare-price]');

        price.classList.remove('d-none');

        regularPrices.forEach((regularPrice) => {
          regularPrice.textContent = Shopify.formatMoney(this.currentVariant.price, window.moneyFormat);
        });

        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          price.classList.add('product-price--on-sale');

          comparePrices.forEach((comparePrice) => {
            comparePrice.textContent = Shopify.formatMoney(this.currentVariant.compare_at_price, window.moneyFormat);
          });
        } else {
          price.classList.remove('product-price--on-sale');
        }
      }

      if (unitPriceWrapper) {
        const unitPrice = unitPriceWrapper.querySelector('[data-product-unit-price]');
        const unitMeasurement = unitPriceWrapper.querySelector('[data-product-unit-measurement]');

        if (this.currentVariant.unit_price) {
          unitPriceWrapper.classList.remove('d-none');
          unitPrice.textContent = Shopify.formatMoney(this.currentVariant.unit_price, window.moneyFormat);
          unitMeasurement.textContent = this.currentVariant.unit_price_measurement.reference_unit;
        } else {
          unitPriceWrapper.classList.add('d-none');
        }
      }

      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }

    toggleAddButton(disable = true, text) {
      const productForm = this.product.querySelector('product-form');

      if (!productForm) {
        return;
      }

      const productSubmitButton = productForm.querySelector('[name="add"]');
      const productSubmitButtonText = productForm.querySelector('[data-product-submit-text]');

      if (!productSubmitButton) {
        return;
      }

      if (disable) {
        productSubmitButton.setAttribute('disabled', 'disabled');

        if (text) {
          productSubmitButtonText.textContent = text;
        }
      } else {
        // Removed as it breaks the prescription code
        productSubmitButton.removeAttribute('disabled');
        productSubmitButton.removeAttribute('aria-disabled');
        productSubmitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    setUnavailable() {
      const productForm = this.product.querySelector('product-form');
      const productSubmitButton = productForm.querySelector('[name="add"]');
      const productSubmitButtonText = productForm.querySelector('[data-product-submit-text]');
      const price = this.product.querySelector('[data-product-price]');

      if (!productSubmitButton) {
        return;
      }

      productSubmitButton.setAttribute('disabled', 'disabled');
      productSubmitButtonText.textContent = window.variantStrings.unavailable;

      if (price) {
        price.classList.add('d-none');
      }
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  if (!customElements.get('variant-radios')) {
    class VariantRadios extends VariantSelects {
      constructor() {
        super();
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));

        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
      }
    }

    customElements.define('variant-radios', VariantRadios);
  }
}

if (!customElements.get('color-swatches')) {
  class ColorSwatches extends HTMLElement {
    constructor() {
      super();

      this.product = this.closest('[data-product]');
      this.variants = this.querySelectorAll('input');

      if (this.variants.length) {
        this.variants.forEach((variant) => {
          variant.addEventListener('click', this.updateVariant.bind(this));
        });
      }
    }

    updateVariant(event) {
      const optionValue = event.target.value;
      const optionName = event.target.getAttribute('name');
      const matchingSelect = this.product.querySelector(
        `variant-selects select[name="options[${optionName.replace('color-swatch-', '')}]"]`,
      );
      const matchingRadio = this.product.querySelector(
        `variant-radios input[value="${optionValue}"][name="${optionName.replace('color-swatch-', '')}"]`,
      );

      if (matchingSelect) {
        matchingSelect.value = optionValue;
        matchingSelect.closest('variant-selects').dispatchEvent(new Event('change'));
      }

      if (matchingRadio) {
        matchingRadio.click();
      }
    }
  }

  customElements.define('color-swatches', ColorSwatches);
}
